// extracted by mini-css-extract-plugin
export default {"tasks":"oN-z","task":"pN-z","svg":"qN-z","text":"rN-z"};